import { IOID4VCIClientCreateOfferUriResponse } from "@sphereon/ssi-sdk.oid4vci-issuer-rest-client";
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import QRCode from "react-qr-code";
import agent from "src/agent";
import PersonalizedHotelPackage from "./PersonalizedHotelPackage";
import PersonalizedPreCheckinExperience from "./PersonalizedPreCheckinExperience";
const short = require("short-uuid");

interface GuestInformationProps {
  //onOptionChosen: (option: string) => void;
  option?: string;
}

const GuestInformation = (props: GuestInformationProps) => {
  const [qrUrl, setQrUrl] = useState<string>("");
  const [infoReceived, setInfoReceived] = useState<boolean>(false);
  const [fullName, setFullName] = useState<string>("");

  let agentbaseUrl = process.env.REACT_APP_BACKEND_BASE_URI;

  let getToken = async () =>  {
    let maenadaUrlTransaction= "https://maenada-oid4vc-issuer.test.veridos-egov.com/oauth2/token";

    let formData = new FormData();
    formData.append('grant_type', 'client_credentials');

    let response = await fetch(maenadaUrlTransaction, {
      method: "POST",
      mode: 'cors',
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Authorization": "Basic dmVyaWZpZXItdWktY2xpZW50OnNlY3JldDI="
      },
      body: formData,
    });
    let token = await response.json();
    await getVCRequestUrl(token.access_token);
    //console.log(transactionInfo);
    return token.access_token;
  }

  let getVCRequestUrl = async (token: string) =>  {
        
    // let response = await fetch(agentbaseUrl + "/webapp/definitions/" + credType + "/auth-requests", {
    //     method: "POST",
    //     mode: 'cors',
    //     headers: {
    //       Accept: "*/*",
    //       "Content-Type": "application/json"
    //     }
    //   });
    //   let responseJson = await response.json();
      
    //   let qrUri = responseJson.authRequestURI;

    //   waitForResponse(responseJson.correlationId, responseJson.definitionId);   

    //   setQrUrl(qrUri);

    //   return qrUri
    let initTransaction = {
      "presentationRequest": {
          "nonce": "67cOfb9c-eb45-44d0-b26c-89afa3634481",
          "id": "pid-or-photo-id-for-check-in"
      },
      "metadata": {
          "requestObjectUsage": "",
          "urlScheme": "openid4vp://"
      }
    };
    let maenadaUrlTransaction= "https://maenada-oid4vc-verifier.test.veridos-egov.com/openid4vp/transactions";

    let response = await fetch(maenadaUrlTransaction, {
      method: "POST",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      },
      body: JSON.stringify(initTransaction),
    });
    let transactionInfo = await response.json();
          waitForResponse(token, transactionInfo.expandedRepresentation.transaction_id);   
    //console.log(transactionInfo);
    // this.setState({uri: transactionInfo.urlRepresentation, originalUri: transactionInfo.urlRepresentation});
    let qrUri = transactionInfo.urlRepresentation
    setQrUrl(qrUri);
    return qrUri;
 }


let waitForResponse = async(token: string, transactionId:any) => {
    const params = new URLSearchParams(document.location.search);
    const transactionIdParam = params.get('transactionId');
    transactionId = (transactionIdParam != null && transactionIdParam != "") ? transactionIdParam : transactionId;
    let maenadaUrlTransaction= "https://maenada-oid4vc-verifier.test.veridos-egov.com/openid4vp/transactions/" + transactionId;

    let response = await fetch(maenadaUrlTransaction, {
      method: "GET",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      }
    });
    let transactionInfo = await response.json();
    const transactionClaims = transactionInfo.claims ?? {};
    const preferredClaims =
      transactionClaims['org.iso.23220.2'] ??
      transactionClaims['org.iso.23220.1'];
      switch(transactionInfo.status){
        case "VERIFIED":
          if(preferredClaims) {
            setFullName(preferredClaims.given_name + ' ' + preferredClaims.family_name)
          } else {
            setFullName(transactionClaims.given_name + ' ' + transactionClaims.family_name)
          }
          setInfoReceived(true);
          break;
        default:
          setTimeout(() => waitForResponse(token, transactionId), 2000);
          break;
      }
}

let generateNewQRCode = async () => {
    const shortUuid = short.generate();
    await getToken();
  };

  let renderQRCode = () => {
    if (qrUrl != null &&  qrUrl != "")
      return (
        <QRCode className="qr-code-ssi"  value={qrUrl ?? ""} />
      );
    return null;
  }

  useEffect(() => {
    if (props.option === "customized") {
      setInfoReceived(true);
    } else {
      generateNewQRCode();
    }

    
  }, []);

  return (
    <Container fluid className="pricing-area pt-50 pb-90">
      <Container>
        {infoReceived == false ? (
          <Container>
            <Row>
              <Col>
                <div
                  className="section-title text-center"
                  style={{ marginBottom: "50px" }}
                >
                  <h2 className="title">Share your Traveler Profile for an ultra personalized experience</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div
                  className="section-title text-center"
                  style={{ marginBottom: "50px" }}
                >
                  {renderQRCode()}
                </div>
              </Col>
            </Row>
          </Container>
        ) : (
          <Container>
            <Row>
              <Col>
                <div
                  className="section-title text-center"
                  style={{ marginBottom: "50px" }}
                >
                  <PersonalizedPreCheckinExperience fullName={fullName}></PersonalizedPreCheckinExperience>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                
              </Col>
            </Row>
          </Container>
        )}
      </Container>
    </Container>
  );
};

export default GuestInformation;
